import laborColumnUrl from './laborReportColumn.html';
import timeoffColumnUrl from './timeoffReportColumn.html';
import payrollUngroupedColumnUrl from './payrollReportUngroupedColumn.html';
import shiftFeedbackReportColumnUrl from './shiftFeedbackReportColumn.html';

const columUrls = {
  laborColumnUrl,
  timeoffColumnUrl,
  payrollUngroupedColumnUrl,
  shiftFeedbackReportColumnUrl,
};

export default function reportTableColumn() {
  return {
    templateUrl($element, $attrs) {
      return columUrls[`${$attrs.reportTableColumn || 'labor'}ColumnUrl`];
    },
    scope: {
      data: '<',
      user: '<',
      type: '<',
      schema: '<',
      isTotals: '<',
      isUserRow: '<',
      showDurationsAsDecimals: '<',
      selectedLeaveTypeIds: '<',
    },
    controllerAs: 'ctrl',
    controller(Authentication, Utils, $scope) {
      'ngInject';

      this.Authentication = Authentication;
      this.Utils = Utils;

      this.getPayrollStatusTooltip = (user, status) => {
        if (status === 'pending') {
          return `${user.name} has at least one unapproved timesheet in this time period`;
        }
      };

      this.eval = (exp) =>
        this.Utils.evaluateExpression(exp, {
          options: {
            showDurationsAsDecimals: $scope.showDurationsAsDecimals,
          },
        });

      this.shouldDisplayEmptyCell = () => {
        const schemaItem = $scope.schema?.[$scope.type];
        return !$scope.isUserRow && $scope.isTotals && schemaItem && !schemaItem.sumUp;
      };

      this.max = (...args) => Math.max(...args);
    },
  };
}
